// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageAllMessage {
  /* display: none; */
  display: flex;
  /* flex: 1 1 25%; */
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  /* padding: 2em; */
  height: 100%;
  width: 100%;
  min-height: 45rem;

  /* max-width: 22rem; */
}

.messageAllMessage > div:first-of-type {
  width: 100%;
}

.messageAllMessage__searchInput {
  display: flex;
  flex: 1 1 30%;
  position: relative;
  align-items: center;
  border-radius: 1em;
  gap: 1rem;
  padding: 1em;
  background: var(--clr-gray);
  border: 0.15rem solid transparent;
}

.messageAllMessage__searchInput svg {
  width: 1.25rem;
  display: block;
}

.messageAllMessage__searchInput input {
  border: none;
  outline: none;
  font-size: 1rem;
  width: 100%;
  background: transparent;
}

.messageAllMessage__searchInput:focus-within {
  border: 0.15rem solid var(--clr-dark);
  background: var(--clr-light);
}

.messageAllMessage__searchInput .messageAllMessage__inputClose {
  display: flex;
  pointer-events: all;
  right: 1rem;
  width: 1rem;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}

.messageAllMessage__cards {
  margin-top: 2rem;
  /* width: 100%; */
  height: 100%;
  max-height: 30rem;
  scrollbar-width: thin;
  scrollbar-track-color: transparent;
  overflow-y: auto;
  overflow-x: hidden;
}

.messageAllMessage__cards .loading-container-text {
  height: 63vh;
  font-size: 1rem;
  padding: 2em;
  text-align: center;
}

.messageAllMessage__cards::-webkit-scrollbar {
  width: 0.5rem;
}

.messageAllMessage__cards::-webkit-scrollbar-track {
  background-color: transparent;
}

.messageAllMessage__cards::-webkit-scrollbar-thumb {
  background: var(--clr-primary-dark);
  border-radius: 3rem;
}

.messageAllMessage__card {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  /* width: 100%; */
  background: var(--clr-gray200);
  padding: 0 1.5em;
  padding: 1em;
  border-radius: 1em;
  /* width: calc(100% + 4rem); */
  /* margin-left: -2rem; */
  position: relative;
  cursor: pointer;
}
.messageAllMessage__card > div {
  width: 100%;
}

.messageAllMessage__imgPerson {
  width: 100%;
  max-width: 3.5rem;
  height: 3.5rem;
  aspect-ratio: 1 / 1;
  background: var(--clr-gray200);
  object-fit: cover;
  margin-right: 1rem;
  border-radius: 50%;
}

.messageAllMessage__cardTop,
.messageAllMessage__cardBottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-size: 1rem;
}

.messageAllMessage__cardTop h3 {
  font-family: "Avenir Next";
  font-weight: bolder;
  color: var(--clr-gray800);
  font-size: 0.9rem;
  width: 8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

messageAllMessage__cardTop h .messageAllMessage__time {
  color: var(--clr-gray800);
  font-size: 0.75rem;
}

.messageAllMessage__cardBottom {
  margin-top: 0.5rem;
}

.messageAllMessage__name {
  color: var(--clr-gray500);
  font-size: 0.9rem;
}

.messageAllMessage__unread {
  display: grid;
  place-items: center;
  border-radius: 50%;
  width: 1.25rem;
  height: 1.25rem;
  font-weight: bold;
  font-size: 0.8rem;
  background: #ecd9d9;
  color: var(--clr-primary);
}

.messageAllMessage__btnNewReservation {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-inline: 1em;
  font-weight: bold;
  color: var(--clr-primary);
  border-radius: 1em;
}

.messageAllMessage__btnNewReservation svg {
  width: 1.25rem;
  margin-right: 0.5rem;
}
@media (min-width: 425px) {
  .messageAllMessage__cardTop h3 {
    width: 13rem;
  }
}
@media (min-width: 600px) {
  .messageAllMessage__cardTop h3 {
    width: 22rem;
  }
}
@media (min-width: 768px) {
  .messageAllMessage__cardTop h3 {
    width: 30rem;
  }
}

@media (min-width: 992px) {
  .messageAllMessage__cardTop.full-width h3 {
    width: 10rem;
  }

  .messageAllMessage {
    background: var(--clr-gray200);
    height: 100%;
    width: 100%;
    padding: 2em 1em;
    border-radius: 0;
    box-shadow: 0rem 0.75rem 1rem rgba(0, 0, 0, 0.04);
  }

  .messageAllMessage__card.active::after {
    content: "";
    position: absolute;
    background: var(--clr-primary);
    width: 0.2rem;
    left: 0;
    height: 100%;
  }

  .messageAllMessage__card.active .messageAllMessage__cardTop h3 {
    color: var(--clr-primary);
  }

  .messageAllMessage__cards {
    margin-left: -1rem;
    padding-right: 1em;
  }
  .messageAllMessage__card {
    margin-top: 1.5rem;
    background: var(--clr-gray200);
    padding: 0 1em;
    border-radius: 1em;
    width: calc(100% + 2rem);
  }

  .messageAllMessage__cardTop h3 {
    width: 8rem;
  }
}

@media (min-width: 1200px) {
  .messageAllMessage {
    flex: 1 1 25%;
    border-radius: 0;
    max-width: 22rem;
    height: 100%;
    border-right: 0.1rem solid var(--clr-gray);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MessageComponents/MessageAllMessage/MessageAllMessage.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;;EAEjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iDAAiD;EACnD;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;IACb,OAAO;IACP,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,0CAA0C;EAC5C;AACF","sourcesContent":[".messageAllMessage {\n  /* display: none; */\n  display: flex;\n  /* flex: 1 1 25%; */\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  /* padding: 2em; */\n  height: 100%;\n  width: 100%;\n  min-height: 45rem;\n\n  /* max-width: 22rem; */\n}\n\n.messageAllMessage > div:first-of-type {\n  width: 100%;\n}\n\n.messageAllMessage__searchInput {\n  display: flex;\n  flex: 1 1 30%;\n  position: relative;\n  align-items: center;\n  border-radius: 1em;\n  gap: 1rem;\n  padding: 1em;\n  background: var(--clr-gray);\n  border: 0.15rem solid transparent;\n}\n\n.messageAllMessage__searchInput svg {\n  width: 1.25rem;\n  display: block;\n}\n\n.messageAllMessage__searchInput input {\n  border: none;\n  outline: none;\n  font-size: 1rem;\n  width: 100%;\n  background: transparent;\n}\n\n.messageAllMessage__searchInput:focus-within {\n  border: 0.15rem solid var(--clr-dark);\n  background: var(--clr-light);\n}\n\n.messageAllMessage__searchInput .messageAllMessage__inputClose {\n  display: flex;\n  pointer-events: all;\n  right: 1rem;\n  width: 1rem;\n  cursor: pointer;\n  top: 50%;\n  transform: translateY(-50%);\n  position: absolute;\n}\n\n.messageAllMessage__cards {\n  margin-top: 2rem;\n  /* width: 100%; */\n  height: 100%;\n  max-height: 30rem;\n  scrollbar-width: thin;\n  scrollbar-track-color: transparent;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.messageAllMessage__cards .loading-container-text {\n  height: 63vh;\n  font-size: 1rem;\n  padding: 2em;\n  text-align: center;\n}\n\n.messageAllMessage__cards::-webkit-scrollbar {\n  width: 0.5rem;\n}\n\n.messageAllMessage__cards::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.messageAllMessage__cards::-webkit-scrollbar-thumb {\n  background: var(--clr-primary-dark);\n  border-radius: 3rem;\n}\n\n.messageAllMessage__card {\n  display: flex;\n  align-items: center;\n  margin-top: 1rem;\n  /* width: 100%; */\n  background: var(--clr-gray200);\n  padding: 0 1.5em;\n  padding: 1em;\n  border-radius: 1em;\n  /* width: calc(100% + 4rem); */\n  /* margin-left: -2rem; */\n  position: relative;\n  cursor: pointer;\n}\n.messageAllMessage__card > div {\n  width: 100%;\n}\n\n.messageAllMessage__imgPerson {\n  width: 100%;\n  max-width: 3.5rem;\n  height: 3.5rem;\n  aspect-ratio: 1 / 1;\n  background: var(--clr-gray200);\n  object-fit: cover;\n  margin-right: 1rem;\n  border-radius: 50%;\n}\n\n.messageAllMessage__cardTop,\n.messageAllMessage__cardBottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 1rem;\n}\n\n.messageAllMessage__cardTop h3 {\n  font-family: \"Avenir Next\";\n  font-weight: bolder;\n  color: var(--clr-gray800);\n  font-size: 0.9rem;\n  width: 8rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nmessageAllMessage__cardTop h .messageAllMessage__time {\n  color: var(--clr-gray800);\n  font-size: 0.75rem;\n}\n\n.messageAllMessage__cardBottom {\n  margin-top: 0.5rem;\n}\n\n.messageAllMessage__name {\n  color: var(--clr-gray500);\n  font-size: 0.9rem;\n}\n\n.messageAllMessage__unread {\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  width: 1.25rem;\n  height: 1.25rem;\n  font-weight: bold;\n  font-size: 0.8rem;\n  background: #ecd9d9;\n  color: var(--clr-primary);\n}\n\n.messageAllMessage__btnNewReservation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding-inline: 1em;\n  font-weight: bold;\n  color: var(--clr-primary);\n  border-radius: 1em;\n}\n\n.messageAllMessage__btnNewReservation svg {\n  width: 1.25rem;\n  margin-right: 0.5rem;\n}\n@media (min-width: 425px) {\n  .messageAllMessage__cardTop h3 {\n    width: 13rem;\n  }\n}\n@media (min-width: 600px) {\n  .messageAllMessage__cardTop h3 {\n    width: 22rem;\n  }\n}\n@media (min-width: 768px) {\n  .messageAllMessage__cardTop h3 {\n    width: 30rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .messageAllMessage__cardTop.full-width h3 {\n    width: 10rem;\n  }\n\n  .messageAllMessage {\n    background: var(--clr-gray200);\n    height: 100%;\n    width: 100%;\n    padding: 2em 1em;\n    border-radius: 0;\n    box-shadow: 0rem 0.75rem 1rem rgba(0, 0, 0, 0.04);\n  }\n\n  .messageAllMessage__card.active::after {\n    content: \"\";\n    position: absolute;\n    background: var(--clr-primary);\n    width: 0.2rem;\n    left: 0;\n    height: 100%;\n  }\n\n  .messageAllMessage__card.active .messageAllMessage__cardTop h3 {\n    color: var(--clr-primary);\n  }\n\n  .messageAllMessage__cards {\n    margin-left: -1rem;\n    padding-right: 1em;\n  }\n  .messageAllMessage__card {\n    margin-top: 1.5rem;\n    background: var(--clr-gray200);\n    padding: 0 1em;\n    border-radius: 1em;\n    width: calc(100% + 2rem);\n  }\n\n  .messageAllMessage__cardTop h3 {\n    width: 8rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .messageAllMessage {\n    flex: 1 1 25%;\n    border-radius: 0;\n    max-width: 22rem;\n    height: 100%;\n    border-right: 0.1rem solid var(--clr-gray);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
